import { render, staticRenderFns } from "./ReviewDashboardProfee.vue?vue&type=template&id=7c9efdab&scoped=true&"
import script from "./ReviewDashboardProfee.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboardProfee.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboardProfee.vue?vue&type=style&index=0&id=7c9efdab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9efdab",
  null
  
)

export default component.exports